import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetNotifications(params = {}) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/notification/`,
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetUnreadCount() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/notification/unread-count`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMarkNotificationRead(id) {
    return axios.request({
        method: 'patch',
        url: `${getApiUrl()}/notification/${id}/read`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMarkAllNotificationsRead() {
    return axios.request({
        method: 'patch',
        url: `${getApiUrl()}/notification/read-all`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteNotification(id) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/notification/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSendCustomNotification(recipients, subject, body) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/notification/custom`,
        data: { recipients, subject, body },
        withCredentials: true,
        crossorigin: true,
    });
}
